import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import NotFoundImage from "./assets/not-found.png";
import ThemeProvider from "@mui/material/styles/ThemeProvider";

const message = `a boy lying in a hammock next to a potted plant, 
  using his laptop with a 404 message on the screen`;

export default function NotFound(props) {
  return (
    <>
      <ThemeProvider theme={props.theme}>
        <Container
          sx={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid
            container
            gap={12}
            direction="row"
            justifyContent="center"
            alignItems="center"
            alignSelf="center"
          >
            <Grid item xs={4.5}>
              <Container maxWidth="sm">
                <Typography
                  variant="h1"
                  sx={{ color: "primary.dark", fontSize: 96 }}
                >
                  404
                </Typography>
                <Typography
                  variant="h1"
                  sx={{ marginTop: "24px", color: "primary.dark" }}
                >
                  Oh no! Page not found.
                </Typography>
                <Typography variant="body1" sx={{ marginTop: "20px" }}>
                  It seems like that this page has found a new place to go, but
                  you can try 3 simple things:
                </Typography>

                <ul
                  style={{
                    marginTop: "20px",
                    listStyle: "inside",
                    marginLeft: "0.5rem",
                  }}
                >
                  <li>Check if the URL contains some mistyping;</li>
                  <li>Hit the back button on your browser;</li>
                  <li>Go to the home page and start again from there.</li>
                </ul>
              </Container>
            </Grid>
            <Grid item xs={5.5}>
              <img src={NotFoundImage} alt={message} width={627} />
            </Grid>
          </Grid>
        </Container>
      </ThemeProvider>
    </>
  );
}
